var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BrowserErrorTypes, EventTypes, BrowserBreadcrumbTypes, ConsoleTypes, BreadcrumbLevel } from '@heimdallr-sdk/types';
import { generateUUID, formatDate } from '@heimdallr-sdk/utils';
var errorPlugin = {
    name: 'jsErrorPlugin',
    monitor: function (notify) {
        var _this = this;
        window.addEventListener('error', function (e) {
            e.preventDefault();
            _this.log(e, ConsoleTypes.ERROR);
            notify({
                category: EventTypes.ERROR,
                data: e
            });
        }, true);
    },
    transform: function (collectedData) {
        var category = collectedData.category, data = collectedData.data;
        var _a = data.target || {}, localName = _a.localName, src = _a.src, href = _a.href;
        var id = generateUUID();
        var time = formatDate();
        if (localName) {
            var resourceData = {
                source_type: localName,
                href: src || href
            };
            this.breadcrumb.unshift({
                eventId: id,
                type: BrowserBreadcrumbTypes.RESOURCE,
                level: BreadcrumbLevel.FATAL,
                message: "Unable to load \"".concat(resourceData.href, "\"")
            });
            var breadcrumb_1 = this.breadcrumb.getStack();
            return {
                id: id,
                time: time,
                type: category,
                breadcrumb: breadcrumb_1,
                data: __assign({ sub_type: BrowserErrorTypes.RESOURCEERROR }, resourceData)
            };
        }
        var _b = data, message = _b.message, lineno = _b.lineno, colno = _b.colno, filename = _b.filename;
        this.breadcrumb.unshift({
            eventId: id,
            type: BrowserBreadcrumbTypes.CODE_ERROR,
            level: BreadcrumbLevel.ERROR,
            message: message
        });
        var breadcrumb = this.breadcrumb.getStack();
        return {
            id: id,
            time: time,
            type: category,
            breadcrumb: breadcrumb,
            data: {
                sub_type: BrowserErrorTypes.CODEERROR,
                message: message,
                lineno: lineno,
                colno: colno,
                filename: filename
            }
        };
    }
};
export default errorPlugin;
